import {
  Avatar, Button, Card, CardContent, CardHeader, Chip, Divider, FormControl, Grid, InputAdornment, 
  InputLabel, List, ListItem, ListItemAvatar, ListItemText, Select, Typography, Dialog
} from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import PageviewIcon from '@material-ui/icons/Pageview';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';

const useStyles = makeStyles((theme) => ({
  root: {},
  fieldsComplementary: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  policyComplementary: {
    display: 'flex',
    alignItems: 'center'
  },
  policyCheckboxComplementary: {
    marginLeft: '-14px'
  },
  submitButtonComplementary: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  contentComplementary: {
    minHeight: 430,
  },
  dividerComplementary: {
    backgroundColor: '#1D3343'
  },
  submitButtonTamamlayiciSatis: {
    marginTop: theme.spacing(2),
    width: '100%'
  }
}));

function ComplementaryProductSales({
  className, ReceiptNo, readonly, tasks, ...rest
}) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const [Price, setPrice] = useState(0);
  const [Warning, setWarning] = useState(false);
  const [WarningType, setWarningType] = useState();
  const [WarningDsc, setWarningDsc] = useState('');
  const [LoadingControl, setLoadingControl] = useState(false);
  const [ComplementaryProductSalesData, setComplementaryProductSalesData] = useState([]);
  const SessionUser = getUser();
  const [SelectedValue, setSelectedValue] = useState([]);
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const [ComplementaryProductSalesType, setComplementaryProductSalesType] = useState(0);
  const [ImagePopup, setImagePopup] = useState(false);
  const [ImageUrl, setImageUrl] = useState('');

  const WarningClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setWarning(false);
  };

  const handleChangeComplementaryProductSalesType = (event) => {
    setComplementaryProductSalesType(event.target.value);
  };
  const MaterialPriceComplementary = (materialCode) => {
    const dataSalesPriceComplementary = {
      MaterialCode: materialCode,
    };
    const configSalesPriceComplementary = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/FileImportExport/SiriusMaterialImage', dataSalesPriceComplementary, configSalesPriceComplementary)
      .then((response) => {
        const fileURLComplementary = URL.createObjectURL(response.data);
        setImageUrl(fileURLComplementary);
        setImagePopup(true);
      }).catch((error) => {
     
      });
  };
  const handleChangePrice = (value) => {
    setPrice(value);
  };
  let currSalesMaterialSum = 0;

  useEffect(() => {
    let mounted = true;
    const fetchTodos = () => {
      axios.get('/GetSalesAccessoryPrice').then((response) => {
        if (mounted) {
          const ResponseData = response.data;
          if (ResponseData.length === 0) {
            setComplementaryProductSalesData([]);
          } else {
            setComplementaryProductSalesData(ResponseData);
          }
          setLoadingControl(false);
        }
      }).catch((error) => {
        setLoadingControl(false);
      });
    };
    fetchTodos();
    return () => {
      mounted = false;
    };
  }, []);

  SelectedValue.forEach((mrow, index) => {
    currSalesMaterialSum += (mrow.Price);
  });

  const setCountValue = (event, MaterialCode) => {
    let SelectionCount = 1;
    if (event.target.value !== '' && event.target.value !== undefined && parseInt(event.target.value) > 0) {
      SelectionCount = event.target.value;
    }
    const selectedChangeData = [];
    SelectedValue.forEach((h, index) => {
      selectedChangeData.push({
        Material: h.Material,
        Count: h.MaterialCode === MaterialCode ? event.target.value : h.Count,
        Price: h.MaterialCode === MaterialCode ? h.Price * SelectionCount : h.Price,
        MaterialCode: h.MaterialCode
      });
    });
    setSelectedValue(selectedChangeData);
  };

  const handleComplementaryProductSales = (event) => {
    confirmAlert({
      message: t('Tamamlayici_confirm'),
      buttons: [
        {
          label: t('Evet'),
          onClick: () => handleComplementaryProductSalesYes()
        },
        {
          label: t('Hayir'),
          onClick: () => { }
        }
      ]
    });
  };
  const handleComplementaryProductSalesYes = () => {
    if (SelectedValue === undefined || SelectedValue.length === 0) {
      setWarningDsc(t('Tamamlayici_malzeme_seciniz'));
      setWarningType('error');
      setWarning(true);
      setLoadingControl(false);
      return;
    }
    setLoadingControl(true);
    const dataSales = [{
      WorkOrderId: ReceiptNo,
      EmployeeId: SessionUser.TechnicianId,
      ComplementaryProductSalesType,
      Price,
      ComplementaryProductSalesMaterial: SelectedValue,
    }];
    const configSales = {
      headers: { 'Content-Type': 'application/json' }
    };

    axios.post('/SetComplementaryProductSales', dataSales, configSales).then((response) => {
      setLoadingControl(false);
      const res = response.data;
      if (parseInt(res) !== 0) {
        setWarningDsc(res);
        setWarningType('error');
        setWarning(true);
        setLoadingControl(false);
      } else {
        setWarningDsc(t('success_message'));
        setWarningType('success');
        setWarning(true);
        setLoadingControl(false);
        setComplementaryProductSalesType(0);
        setPrice(0);
        setSelectedValue([]);
      }
    }).catch((error) => {
      setWarningDsc(t('Error'));
      setWarningType('error');
      setWarning(true);
      setLoadingControl(false);
    });
  };

  return (
    <>
      <Card className={clsx(classes.root, className)}>
        <CardHeader title={t('Tamamlayici_urun_satis')} />
        <Divider />
        {
          Warning
            ? <Alert onClose={WarningClose} open={Warning} message={WarningDsc || ''} variant={WarningType} />
            : <div />
        }
        {
          LoadingControl
            ? (
              <CircularProgress
                status="loading"
                style={{ marginLeft: '50%' }}
              />
            )
            : (
              <CardContent className={classes.contentComplementary}>
                <Autocomplete
                  multiple
                  limitTags={1}
                  id="checkboxes-tags-demo"
                  options={ComplementaryProductSalesData}
                  disableCloseOnSelect
                  onChange={(event, newValue) => {
                    newValue.forEach((h, index) => {
                      SelectedValue.forEach((i, index1) => {
                        if (i.MaterialCode === h.Material) {
                          h.Count = i.Count;
                          h.Price = i.Price;
                        }
                      });
                    });
                    setSelectedValue(newValue);
                  }}
                  getOptionLabel={(option) => `${option.MaterialCode}-${option.Material}`}
                  renderOption={(option, { selected }) => (
                    <>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        checked={selected}
                      />
                      {option.MaterialCode}
                      -
                      {option.Material}
                      -
                      {option.Price}
                    </>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label={t('Tamamlayici_urun')}
                    />
                  )}
                />
                <br />
                <Divider className={classes.dividerComplementary} />
                <br />
                <List className={classes.root}>
                  {SelectedValue.map((log) => (
                    <div key={log.MaterialCode}>
                      <ListItem alignItems="flex-start">
                        <ListItemAvatar onClick={() => MaterialPriceComplementary(log.MaterialCode)}>
                          <Avatar style={{ backgroundColor: '#1D3343' }}>
                            <PageviewIcon />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText>
                          <Grid container spacing={1}>
                            <Grid item xs={10} sm={10}>
                              {`${log.MaterialCode}-${log.Material} `}
                              <Chip size="small" label={`${log.Price.toFixed(2)} ${SessionUser.CurrencyUnit}`} color="secondary" />
                            </Grid>
                            <Grid item xs={2} sm={2}>
                              <TextField
                                id="standard-number"
                                label={t('Adet')}
                                type="number"
                                size="small"
                                autocomplete="off"
                                onChange={(e) => setCountValue(e, log.MaterialCode)}
                                value={log.Count}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                            </Grid>
                          </Grid>
                        </ListItemText>
                      </ListItem>
                      <Divider variant="inset" component="li" />
                    </div>
                  ))}
                </List>
                <br />
                <Divider className={classes.dividerComplementary} />
                <br />
                <FormControl variant="outlined" className={classes.submitButtonTamamlayiciSatis}>
                  <InputLabel id="demo-simple-select-outlined-label" disabled={readonly}>{t('Tahsilat_Tipi')}</InputLabel>
                  <Select
                    fullWidth
                    native
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    onChange={handleChangeComplementaryProductSalesType}
                    label={t('Tahsilat_Tipi')}
                    hidden
                    value={ComplementaryProductSalesType}
                  >
                    <option value={0} />
                    <option value={1}>{t('Nakit')}</option>
                    <option value={2}>{t('Kredi_karti')}</option>
                    <option value={3}>{t('Senet')}</option>
                    <option value={4}>{t('Borc')}</option>
                    <option value={5}>{t('Diger')}</option>
                  </Select>
                </FormControl>
                <br />
                <br />
                <Divider className={classes.dividerComplementary} />
                <br />
                <br />
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12} align="right">
                    <Typography variant="h6" gutterBottom>
                      {t('Toplam')}
                      {' '}
                      :
                      {currSalesMaterialSum.toFixed(2)}
                    </Typography>
                  </Grid>
                </Grid>
                <br />
                <Divider className={classes.dividerComplementary} />
                <br />
                <TextField
                  name="Tutar"
                  label={t('Tahsilat')}
                  value={Price || ''}
                  type="number"
                  onChange={(e) => handleChangePrice(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start" />
                    ),
                  }}
                  fullWidth
                  variant="outlined"
                />
                <br />
                <br />
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.submitButtonTamamlayiciSatis}
                  onClick={(event) => handleComplementaryProductSales(event)}
                  endIcon={<AddShoppingCartIcon>Satış</AddShoppingCartIcon>}
                >
                  {t('Satis_yap')}
                </Button>
              </CardContent>

            )
        }
      </Card>
      <Dialog
        open={ImagePopup}
        fullWidth
        maxWidth="sm"
        onClose={() => setImagePopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <img width="auto" height="auto" src={ImageUrl} style={{ border: 'none' }} onclick={() => setImagePopup(false)}></img>
      </Dialog>
    </>
  );
}

ComplementaryProductSales.propTypes = {
  className: PropTypes.string,
};


export default connect(
  (state) => ({ tasks: state.tasks1 })
)(ComplementaryProductSales);
